<template>
    <div class="wayPlanning">
        <div class="inputBox">
            <p class="title">确认路径：</p>
            <el-select v-model="furtherWayObj.furtherWay" placeholder="请选择升学路径" style="width: 300px">
                <el-option v-for="(item,index) in wayList" :label="item.name" :value="item.name" :key="index" ></el-option>
            </el-select>
        </div>
        <div class="inputBox">
            <p class="title">路径条件：</p>
            <el-input class="area"   type="textarea" v-model="furtherWayObj.furtherWayNeed"  rows="5" maxLength='500'></el-input>
        </div>
        <div class="inputBox">
            <p class="title">其他条件：</p>
            <el-input class="area"   type="textarea" v-model="furtherWayObj.furtherWayNeedOther"  rows="5" maxLength='500'></el-input>
        </div>
        <div class="summary">
            <SummaryTitle title='咨询记录'/>
            <el-input class="area"   type="textarea" v-model="furtherWayObj.furtherWayRemark"  rows="5" maxLength='500'></el-input>
        </div>
    </div>
</template>
<script>
// import API from '@/api/index.js';
import SummaryTitle from './SummaryTitle.vue';
export default {
    name: "wayPlanning",
    props: ['furtherWayObj'],
    components: {
        SummaryTitle
    },
    data() {
        return {
            // furtherWayObj: {
            //     furtherWay: '',//升学路径
            //     furtherWayNeed:'',//路径条件
            //     furtherWayNeedOther:'',//其他条件
            //     furtherWayRemark: '',//咨询总结
            // },
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            wayList: [
                { name: '普通升学', id:1 },
                { name: '综合评价', id:3 },
                { name: '保送生', id:4 },
                { name: '港澳招生', id:5 },
                { name: '高校专项计划', id:6 },
                { name: '地方专项计划', id:7 },
                { name: '国家专项计划', id:8 },
                // { name: '高水平艺术团', id:9 },
                { name: '高水平运动队', id:10 },
                { name: '艺术类专业', id:11 },
                { name: '体育单招', id:12 },
                { name: '体育类专业', id:13 },
                { name: '航海类专业', id:14 },
                { name: '公费师范生', id:15 },
                { name: '免费医学生', id:16 },
                { name: '中外合作办学', id:17 },
                { name: '公安院校（含刑警、司法）', id:18 },
                { name: '民族预科班', id:19 },
                { name: '海外留学', id:20 },
                { name: '高职单招', id:21 },
                { name: '空军招飞', id:22 },
                { name: '海军招飞', id:23 },
                { name: '民航招飞', id:24 },
                { name: '军校招生', id:25 },
                { name: '强基计划', id:26 },
                { name: '公费农科生',id:27},
                { name: '小语种招生',id:28},
                { name:'定向生',id:29},
                { name:'军事院校（含武警）',id:30},

                



            ]
        }
    },
    computed:{
    },
    watch: {

    },
    methods:{
    },
    created() {

    },
    mounted(){
    },

}
</script>
<style scoped lang="less">
.wayPlanning {
    padding: 26px 0px;
    .inputBox {
        display: flex;
        margin-bottom: 23px;
        .title {
            line-height: 40px;
            span {
                color: red;
            }
        }
        .area {
            flex: 1;
        }
    }
}
</style>
<style lang="less">
.wayPlanning {
    input {
        border: 1px solid #EAEAEA;
    }
}
</style>

